import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cbc7f7e0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "sell-point-audit"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查询");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 通过 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 驳回 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_7 = {
  class: "reject-text"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("驳回");

import { ref } from 'vue';
import { dateFormat, getVexTableProps, auditStatusOptions, administratorOptions } from '@/config';
import { getSellPointAuditList, passAudit, rejectAudit } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import EditProductSellPointModal from './component/EditProductSellPointModal.vue';
export default {
  name: 'SellPointAudit',

  setup(__props) {
    const showModal = ref(false);
    const editData = ref(null);
    const showRejectModal = ref(false);
    const rejectReason = ref('');
    const form = ref({
      merKeyword: '',
      manufacture: '',
      startTime: '',
      endTime: '',
      linkMan: '',
      supplierName: '',
      administrator: '',
      checkStatus: '0'
    });
    const table = ref();

    function initForm(source = {
      merKeyword: '',
      manufacture: '',
      startTime: '',
      endTime: '',
      linkMan: '',
      supplierName: '',
      administrator: '',
      checkStatus: ''
    }) {
      form.value = _objectSpread(_objectSpread({}, form.value), source);
    }

    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'checkStatusVal',
        title: '审核状态',
        width: '100px'
      }, {
        title: '商品编码',
        field: 'prodNo',
        width: '250px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '250px'
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '厂家',
        field: 'manufacture',
        width: '150px',
        showOverflow: 'tooltip'
      }, {
        title: '原品牌名',
        field: 'originalBrandName',
        width: '150px',
        showOverflow: true
      }, {
        title: '新品牌名',
        field: 'brandName',
        width: '150px',
        showOverflow: true
      }, {
        title: '原别名',
        field: 'originalProdAlias',
        width: '150px',
        showOverflow: true
      }, {
        title: '新别名',
        field: 'prodAlias',
        width: '150px',
        showOverflow: true
      }, {
        title: '原卖点',
        field: 'originalMerIntroduction',
        width: '150px',
        showOverflow: true
      }, {
        title: '新卖点',
        field: 'merIntroduction',
        width: '150px',
        showOverflow: true
      }, {
        title: '原产品优势',
        field: 'originalSalesTalk',
        width: '250px',
        showOverflow: true
      }, {
        title: '新产品优势',
        field: 'salesTalk',
        width: '250px',
        showOverflow: true
      }, {
        title: '驳回原因',
        field: 'rejectReason',
        width: '250px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }, {
        title: '团队层级',
        field: 'administrator',
        width: '100px'
      }, {
        title: '提交人电话',
        field: 'linkPhone',
        width: '150px'
      }, {
        title: '提交时间',
        field: 'createAt',
        width: '200px'
      }, {
        title: '审核时间',
        field: 'checkDate',
        width: '200px'
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '100px',
        slots: {
          default: 'operation'
        }
      }],
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return row.checkStatus === '0';
        }

      },
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSellPointAuditList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function search() {
      table.value.commitProxy('reload');
    }

    function reset() {
      initForm();
      table.value.commitProxy('reload');
    }

    function edit(row) {
      editData.value = row;
      showModal.value = true;
    }

    function pass() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage({
          showClose: true,
          message: '请勾选商品后再进行操作!',
          type: 'warning'
        });
        return;
      }

      ElMessageBox.confirm(`确认要审核通过${selectRows.length}条数据?`, {
        title: '通过'
      }).then(() => {
        passAudit({}, {
          params: {
            auditIdS: selectRows.map(prod => prod.supMerMaterialAuditId).join(','),
            flagType: 1,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage({
              showClose: true,
              message: '操作成功!',
              type: 'success'
            });
            search();
            showRejectModal.value = false;
          }
        });
      });
    }

    let rejectLen = ref(0);

    function fail() {
      const selectRows = table.value.getCheckboxRecords();
      rejectLen.value = selectRows.length;

      if (!selectRows.length) {
        ElMessage({
          showClose: true,
          message: '请勾选商品后再进行操作!',
          type: 'warning'
        });
        return;
      }

      rejectReason.value = '';
      showRejectModal.value = true;
    }

    function rejectAuditHandle() {
      const selectRows = table.value.getCheckboxRecords();
      rejectAudit({}, {
        params: {
          auditIdS: selectRows.map(prod => prod.supMerMaterialAuditId).join(','),
          flagType: 1,
          rejectReason: rejectReason.value,
          __repeat: true,
          __warn: true
        }
      }).then(data => {
        if (data.success) {
          ElMessage({
            showClose: true,
            message: '操作成功!',
            type: 'success'
          });
          search();
        }
      }).finally(() => {
        showRejectModal.value = false;
      });
    }

    function editSuccess() {
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        "label-width": "80px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.merKeyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.merKeyword = $event),
                placeholder: "输入商品名/编号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "厂家"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.manufacture,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.manufacture = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "提交开始时间",
              "label-width": "110px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "提交结束时间",
              "label-width": "110px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.endTime = $event),
                "value-format": _unref(dateFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "提交人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属团队"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队层级"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.administrator,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.administrator = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(administratorOptions), option => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: option.label,
                    value: option.value,
                    key: option.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "审核状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.checkStatus,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.checkStatus = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auditStatusOptions), statu => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: statu.label,
                    value: statu.value,
                    key: statu.label
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: search
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "CircleCheck",
          type: "primary",
          onClick: pass
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "CircleClose",
          type: "danger",
          onClick: fail
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [row.checkStatus === '0' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(EditProductSellPointModal, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showModal.value = $event),
        editData: editData.value,
        onSuccess: editSuccess
      }, null, 8, ["modelValue", "editData"]), _createVNode(_component_el_dialog, {
        modelValue: showRejectModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showRejectModal.value = $event),
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => showRejectModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: rejectAuditHandle
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, "确认要驳回这" + _toDisplayString(_unref(rejectLen)) + "条数据么", 1), _createVNode(_component_el_form_item, {
          label: "驳回原因:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: rejectReason.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => rejectReason.value = $event),
            placeholder: "最多输入100字",
            type: "textarea",
            maxlength: "100",
            autosize: {
              minRows: 4,
              maxRows: 6
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};